import { ComponentProps } from "react";

export const EmptyImage = (props: ComponentProps<"svg">) => (
  <svg width={107} height={68} fill="none" {...props}>
    <path
      d="M47.42 6.728l.449.54H90.5V66.5H25.71a6.17 6.17 0 01-4.387-1.828 6.243 6.243 0 01-1.823-4.418V2.5h24.398l3.521 4.228z"
      fill="#2D7FAF"
      stroke="#2D7FAF"
      strokeWidth={3}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.74 39.455c9.576-1.406 16.927-9.655 16.927-19.622C39.667 8.88 30.787 0 19.833 0 8.88 0 0 8.88 0 19.833c0 5.857 2.538 11.12 6.575 14.751 2.644 2.925 9.72 9.625 19.73 10.51 0 0-2.393-.71-3.548-5.57a2.75 2.75 0 00-.017-.069z"
      fill="#96BFD7"
    />
    <path
      d="M17 28.717c0-.753.214-1.321.643-1.706.428-.385 1.052-.578 1.871-.578.82 0 1.403.197 1.836.591.433.394.65.958.65 1.693 0 .734-.22 1.265-.657 1.672-.438.407-1.048.611-1.829.611-.78 0-1.419-.2-1.857-.598-.438-.398-.657-.96-.657-1.685zm2.529-4.594c-.977 0-1.783-.72-1.834-1.637l-.509-9.165c-.07-1.262 1-2.321 2.343-2.321s2.412 1.059 2.342 2.32l-.508 9.166c-.052.918-.857 1.637-1.834 1.637z"
      fill="#fff"
    />
    <path
      d="M99.263 66.75H31.21a9.02 9.02 0 002.778-6.526V16.25h71.763v43.974c0 3.611-2.909 6.526-6.487 6.526z"
      fill="#fff"
      stroke="#2D7FAF"
      strokeWidth={2.5}
    />
    <circle cx={62} cy={39} r={3} fill="#2D80AF" />
    <circle cx={78} cy={39} r={3} fill="#2D80AF" />
    <rect x={61} y={45} width={17} height={2} rx={1} fill="#2D80AF" />
  </svg>
);
